import type { en } from 'c-translation/Langs';
import type { DeepPartial } from 'c-types';

const enUS: DeepPartial<typeof en> = {
    Modules: {
        Main: {
            Campaigns: {
                Overview: {
                    ActionLabels: {
                        customizeSummary: 'Customize Summary',
                    },
                },
            },
        },
    },
    CommonWords: {
        Impacts: 'Impressions',
        impacts: 'impressions',
        Pack: 'Package',
        pack: 'package',
        TVRegion: 'State',
        TVRegions: 'States',
        Region: 'State',
        Conurbation: 'Market (DMA)',
        // Pluralised on the noun, not the abbreviation — "Market (DMA)s" would be nonsense.
        Conurbations: 'Markets (DMA)',
        Town: 'CBSA',
        Towns: 'CBSAs',
        MediaOwners: 'Partners',
        mediaOwners: 'partners',
        MediaOwner: 'Partner',
        owners: 'partners',
        Owners: 'Partners',
        Owner: 'Partner',
        owner: 'partner',
    },
};

export default enUS;
